import React from "react";
import {Warning} from "../../wui-core/src";
import Collapse from "./Collapse";
import Panel from "./Panel";

import {EntranceProps} from "./iCollapse";

const {isShouldUpdate} = Warning;

const CollapseWrapper: React.FC<EntranceProps> & { Panel?: typeof Panel } = (props) => {
    const {onSelect, onChange, ...others} = props;
    isShouldUpdate("Collapse", props);
    const extral = {
        onSelect: onChange ? onChange : onSelect
    };
    return <Collapse {...extral} {...others} />;
};

CollapseWrapper.Panel = Panel;
export default CollapseWrapper;
